/**
 * 클라이언트 사이드에서 다중 리프레시 요청을 방지하기 위한 싱글톤 매니저
 *
 * 여러 API 요청이 동시에 401을 받았을 때, 첫 번째 리프레시만 실행하고
 * 나머지는 동일한 Promise를 공유합니다.
 */
let refreshPromise: Promise<void> | null = null;

/**
 * 리프레시 함수를 싱글톤으로 실행합니다.
 *
 * @param refreshFn - 리프레시 API를 호출하는 함수
 * @returns 리프레시 완료 Promise
 *
 * @example
 * ```typescript
 * // 여러 곳에서 동시에 호출되어도 실제 리프레시는 한 번만 실행됨
 * await executeRefresh(() => refreshAccessTokenClient());
 * ```
 */
export const executeRefresh = async (refreshFn: () => Promise<void>): Promise<void> => {
  // 이미 리프레시 중이면 기존 Promise 반환
  if (refreshPromise) {
    return refreshPromise;
  }

  // 새로운 리프레시 시작
  refreshPromise = refreshFn().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
};
